import {
  GTM_ID
  // pageView
} from './gtm'
import Script from 'next/script'
import { pageTrackerIsAllowed } from 'shared/helpers/pageTrackerTools'
// import { usePathname, useSearchParams } from "next/navigation";
// import { useEffect } from "react";

export default function GoogleTagManager() {
  // const pathname = usePathname();
  // const searchParams = useSearchParams();

  // This needs to be tested live - I don't think we actually need this because currently
  // (Jul 2023) the GTM is always being rendered clientside on every page load, meaning
  // if we call datalayer.push then we'll be double-recording a view, as I _believe_
  // GTM records its own pageview event on load.
  // If that's not the case, then uncomment the code in this file
  // useEffect(() => {
  //   if (pathname) {
  //     pageView(pathname);
  //   }
  // }, [pathname, searchParams]);

  if (!pageTrackerIsAllowed) return null

  return (
    <>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${GTM_ID}');
  `
        }}
      />
    </>
  )
}
